import { z } from 'zod'

export const contactSchema = z.object({
  fullName: z.string().min(2, 'Name is required'),
  email: z.string().email('Invalid email'),
  phone: z.string().refine((val) => {
    const digitsOnly = val.replace(/\D/g, '');
    return digitsOnly.length >= 10;
  }, 'Phone number must be at least 10 digits'),
  eventType: z.string().min(1, 'Please select an event type'),
  eventDate: z.string().min(1, 'Please select a date'),
  venueLocation: z.string().optional(),
  numberOfGuests: z.string().optional(),
  musicPreferences: z.string().optional(),
  additionalNotes: z.string().optional(),
})

export type ContactFormValues = z.infer<typeof contactSchema>
